import {
  type AdServerData,
  type GkAirApiGetGkAirRecommendationsWebRequest,
} from '@redteclab/api/clients/crosssellers-proxy-service'

import { type PublicGlobalConfig } from '../../../global-config'

const getOptionalRequestParams = ({
  adServerData,
  asuid,
  cid,
  expa,
  isAnalyticsConsentGranted,
}: {
  adServerData?: AdServerData | null
  asuid?: string
  cid?: string
  expa?: string
  isAnalyticsConsentGranted: boolean
}): Pick<
  GkAirApiGetGkAirRecommendationsWebRequest,
  'cid' | 'expa' | 'GkAirProxyServiceWebRequest' | 'userid'
> => ({
  ...(adServerData && { GkAirProxyServiceWebRequest: { adServerData } }),
  ...(expa && { expa }),
  ...(cid && { cid }),
  ...(isAnalyticsConsentGranted && asuid && { userid: asuid }),
})

export const recommendationBuildRequestParams = ({
  adServerData,
  asuid,
  cid,
  expa,
  globalConfig,
  isAnalyticsConsentGranted,
  pid,
  plist,
  searchterm,
  sellerid,
  serviceId,
  sid,
}: {
  adServerData?: AdServerData | null
  asuid?: string
  cid?: string
  expa?: string
  globalConfig: Pick<PublicGlobalConfig, 'language' | 'tenantAndEnv'>
  isAnalyticsConsentGranted: boolean
  pid: string
  plist: string
  searchterm?: string
  sellerid?: string
  serviceId: string
  sid: string
}): GkAirApiGetGkAirRecommendationsWebRequest => ({
  ...getOptionalRequestParams({
    adServerData,
    asuid,
    cid,
    expa,
    isAnalyticsConsentGranted,
  }),
  language: globalConfig.language,
  pid,
  plist,
  searchterm,
  sellerid,
  serviceId,
  sid,
  tenant: globalConfig.tenantAndEnv,
  titlekey: globalConfig.language,
  tracking: true,
})
